export const CALENDAR_CLICK_ACTION = {
  DATES_NEXT: 'dates-next-button',
  DATES_PREV: 'dates-prev-button',
  DATES_SELECT: 'dates-select',
  MONTHS_NEXT: 'month-next-button',
  MONTHS_PREV: 'month-prev-button',
  MONTHS_SELECT: 'month-select',
  TITLE_CLICK: 'title-click',
  TODAY_BUTTON_CLICK: 'today-button-click',
  YEARS_NEXT: 'years-next-button',
  YEARS_PREV: 'years-prev-button',
  YEARS_SELECT: 'years-select',
} as const;

export const VIEW_TYPES = {
  DATES: 'dates',
  MONTHS: 'months',
  YEARS: 'years',
} as const;

export const BUTTON_TYPE = {
  NEXT: 'next',
  PREV: 'prev',
} as const;

export const CALENDAR_SIZES = {
  COLS: 3,
  ROWS: 4,
};
